import styled from 'styled-components';

export const Container = styled.header`
    width: 100%;
    background: var(--blue);
    margin: 0;
    padding: 1rem;
`

export const Content = styled.div`
    width: 100%;

    padding: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    button {
        font-size: 1rem;
        color: #FFF;
        background: var(--blue-light);
        border: 0;
        padding: 0 2rem;
        border-radius: 0.25rem;
        height: 3rem;

        transition: filter 0.2s;

        &:hover {
            filter: brightness(0.9);
        }
    }
`